import {useEffect, useRef, useState} from 'react';
import {Link} from 'react-router';
import {Button, Modal, Table} from 'antd';
import {getAllPurchaseOrderLines, updatePurchaseOrderLineState} from "../../api/Api";
import {PurchaseOrderItemStatusType} from "../../api/Constants";
import {PurchaseOrderItemStatusTag} from "../widget/PurchaseOrderItemStatusTag";
import {getColumnSearchProps} from "../widget/SearchProps";

export const RequestedItems = ({onApiFail, refresh, onRefresh, props}) => {
    const [requestedItems, setRequestedItems] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalItem, setModalItem] = useState(undefined);

    useEffect(() => {
        getAllPurchaseOrderLines(PurchaseOrderItemStatusType.InProgress).then(r => {
            const lines = r.map(l => {
                return {
                    ...l,
                    key: l.id
                }
            });
            setRequestedItems(lines);
        }).catch (e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }, [refresh, onApiFail]);

    const searchInput = useRef(null);

    const columns = [
        {
            title: 'Quantity',
            dataIndex: 'quantity',
            key: 'quantity',
            sorter: (a, b) => a.quantity - b.quantity,
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (val, record, index) => {
                let name = val;
                if ((val === undefined) || (val === null)) {
                    name = "none specified"
                }
                return <Link to={`/purchaseorder/${record.purchaseId}/lineItem/${record.id}`}>{name}</Link>
            },
            ...getColumnSearchProps("name", searchInput),
            sorter: (a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (val, record, index) => <PurchaseOrderItemStatusTag item={record} />,
            sorter: (a, b) => a.status - b.status
        },
        {
            title: 'Purchase Order',
            dataIndex: 'poNumber',
            key: 'poNumber',
            render: (val, record, index) => {
                return <Link to={`/purchaseorder/${record.purchaseId}`}>{val}</Link>
            },
            ...getColumnSearchProps(`poNumber`, searchInput),
            sorter: (a, b) => a.poNumber.toLowerCase().localeCompare(b.poNumber.toLowerCase()),
        },
        {
           title: 'Mark Complete',
           dataIndex: 'status',
           key: 'MarkComplete',
           render: (val, record, index) => {
               return <Button onClick={onComplete(record)}>Complete</Button>
           }
        }
    ];

    const onComplete = (record) => () => {
        setModalItem(record);
        setIsModalOpen(true);
    }

    const onModalOk = () => {
        updatePurchaseOrderLineState(modalItem.id, PurchaseOrderItemStatusType.Complete).then(r => {
            if (onRefresh) onRefresh();
        }).catch (e => {})
        setIsModalOpen(false);
    }

    const onModalCancel= () => {
        setIsModalOpen(false);
    }

    return <div>
        <Modal open={isModalOpen} onOk={onModalOk} onCancel={onModalCancel}>
            Marking this item as complete will indicate this work was previously completed.  No further ingredients will be recorded.  Do you wish to continue?
        </Modal>
        <Table dataSource={requestedItems} columns={columns} pagination={false} />
    </div>
}